import React, { useState } from "react";
import {translate} from "../Language/Translate"
import {Button, Form} from 'react-bootstrap';
import { getAllPropertiesFromCsvData } from "../../newForms2/helpers";


const CsvToJsonField = () => {
    const [values, setValues] = useState("");

    const handleChange = e => {
        (() => setValues(e.target.value))();
    };

    
    const handleSubmit = async () => {
        console.log(getAllPropertiesFromCsvData(values));
    };
        return(
        <>
        <div>
            <Form>
                <Form.Group size="lg" controlId={"sql"} >
                    <Form.Label  className ="pt-1 px-1" >CSV-Data from fields table to JSON</Form.Label>
                    <Form.Control as="textarea" rows={5}
                        name={"csv"} 
                        type="textarea" 
                        fieldtype="textarea" 
                        key={"csv"} 
                        value={values}
                        onChange={e => handleChange(e)} 
                    />
                </Form.Group>
                <Button onClick = {() => setValues("")}>{translate("Clear")}</Button>
                <Button className="ml-1" onClick = {handleSubmit}>{translate("Submit")}</Button>
            </Form>
        </div>
        </>
    );
};
export default CsvToJsonField;